// PairUpToday — Authoritative Financial Calculations
// Basis point standard: 10000 bps = 100.00%
// 1500 bps / 10000 = 15.00% platform commission, 85.00% companion payout

export const DEFAULT_PLATFORM_FEE_BPS = 1500;
export const BPS_DENOMINATOR = 10000;

export interface PayoutCalculation {
  grossAmount: number;
  feeBps: number;
  platformFee: number;
  companionPayout: number;
  feePercentage: number;
}

/**
 * Calculates platform commission and companion net payout using fee_bps / 10000
 * @param grossAmount Total gross booking amount in INR
 * @param feeBps Platform fee in basis points (default: 1500 bps = 15%)
 */
export function calculatePayout(
  grossAmount: number,
  feeBps: number = DEFAULT_PLATFORM_FEE_BPS
): PayoutCalculation {
  const safeGross = Math.max(0, Math.round(grossAmount));
  const safeBps = Math.max(0, Math.round(feeBps));

  // Authoritative formula: (gross_amount * fee_bps) / 10000
  const platformFee = Math.round((safeGross * safeBps) / BPS_DENOMINATOR);
  const companionPayout = safeGross - platformFee;
  const feePercentage = (safeBps / BPS_DENOMINATOR) * 100;

  return {
    grossAmount: safeGross,
    feeBps: safeBps,
    platformFee,
    companionPayout,
    feePercentage,
  };
}
